import React from 'react';
import { Link } from 'react-router-dom'; // Импортируем Link для переходов
import '../../styles/gallerySection.css';

function GallerySection({ image, title, description, buttons }) {
  return (
    <section className="gallery-section">
      <div className="gallery-image-container">
        <img src={image} alt={title} className="gallery-image" />
        <div className="gallery-buttons">
          {buttons.map((button, index) => (
            <Link
              key={index}
              to={button.path} // Путь для перехода
              className="gallery-button"
            >
              {button.text} {/* Текст кнопки */}
            </Link>
          ))}
        </div>
      </div>
      <div className="gallery-content">
        <h2 className="gallery-title">{title}</h2>
        <p className="gallery-description">{description}</p>
      </div>
    </section>
  );
}

export default GallerySection;
